import { apiClient } from './client';
import { buildApiEndpoint } from './config';

// Account Types based on the OpenAPI schema
export interface AccountResponse {
  id: string;
  number: string;
  accountNumberDisplay: string;
  realAccountNumberLast4: string;
  name: string;
  balance: number;
  type: string;
  aggregationStatusCode: number;
  status: string;
  institution_id: string;
  balanceDate: number;
  aggregationSuccessDate: number;
  aggregationAttemptDate: number;
  createdDate: number;
  lastUpdatedDate: number;
  lastTransactionDate: number;
  oldestTransactionDate: number;
  marketSegment: string;
  currency: string;
  institutionLoginId: string;
  displayPosition: number;
  accountNickname: string;
  detail: object;
  parentAccount: string;
  position: object[];
  linkedAccountDate: number;
}

// Account Service Class
export class AccountService {
  /**
   * Get accounts by institution ID
   * @param institutionId - The institution ID
   * @returns Promise with accounts data
   */
  public async getAccountsByInstitution(institutionId: string): Promise<AccountResponse[]> {
    try {
      const endpoint = buildApiEndpoint(`institutions/${institutionId}/accounts`);
      const response = await apiClient.get<AccountResponse[]>(endpoint);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch accounts:', error);
      throw error;
    }
  }

  /**
   * Persist selected accounts
   * @param accountIds - Array of selected account IDs to persist
   * @returns Promise with persisted accounts data
   */
  public async persistSelectedAccounts(accountIds: string[]): Promise<any> {
    try {
      const endpoint = buildApiEndpoint('accounts/persist');
      const requestBody = {
        account_ids: accountIds
      };
      const response = await apiClient.post<any>(endpoint, requestBody);
      return response.data;
    } catch (error) {
      console.error('Failed to persist accounts:', error);
      throw error;
    }
  }
}

// Export singleton instance
export const accountService = new AccountService(); 